import React, { memo } from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import ROUTES from "router/routes.constants";
import { useSelector } from "react-redux";
import { selectIsAuthenticated } from "store/slices/user.slice";
import { getToken } from "utils/auth.utils";

const ProtectedRoute = memo(({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  // Cross-check against the raw token, not just the persisted Redux flag.
  // A forced logout can redirect before the persisted snapshot finishes
  // flushing, so a stale `isAuthenticated: true` alone must not let the
  // user back into a protected screen.
  if (isAuthenticated && getToken()) {
    return children;
  }

  return <Navigate to={ROUTES.LOGIN} replace />;
});

ProtectedRoute.displayName = 'ProtectedRoute';

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

const PublicRoute = memo(({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  if (isAuthenticated && getToken()) {
    return <Navigate to={ROUTES.INVESTMENTS} replace />;
  }

  return children;
});

PublicRoute.displayName = 'PublicRoute';

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export { ProtectedRoute, PublicRoute };